export const DATA_LIMIT = 20;
export const USER_STATUS = {
	'internship'        : {key: 'internship',   title: 'Thực tập',      color : 'yellow'},
	'probation'         : {key: 'probation',    title: 'Thử việc',      color : 'blue'},
	'public'            : {key: 'public',       title: 'Chính thức',    color : 'green'},
	'trash'             : {key: 'trash',        title: 'Nghỉ việc',     color : 'red'},
};
export const LIST_SOURCE = [
	{key: 'facebook',       title: 'Facebook',          color: 'blue-bold'},
	{key: 'zalo',           title: 'Zalo',              color: 'blue'},
	{key: 'timviecnhanh',   title: 'Tim Việc Nhanh',    color: 'blue'},
	{key: 'topcv',          title: 'TopCV',             color: 'green'},
	{key: 'vieclam24h',     title: 'Vieclam24h',        color: 'blue' },
	{key: 'vieccoi',        title: 'Vieccoi',           color: 'blue'},
	{key: 'viectotnhat',    title: 'Viectotnhanh',      color: 'blue'},
	{key: 'introduce',      title: 'Được giới thiệu',   color: 'blue'},
	{key: 'other',          title: 'Khác',              color: 'white'},
];
export const LIST_PROJECT_PHASE = {
	'design': {
		label: "Thiết kế",
		color: 'blue',
	},
	'program': {
		label: "Lập trình",
		color: 'green',
	},
	'support': {
		label: "Hỗ trợ",
		color: 'white',
	},
}
export const LIST_PAPER_STATUS = {
	'pending': {
		label: "Đợi phát",
		color: 'yellow',
	},
	'success': {
		label: "Đã phát",
		color: 'green',
	},
	'cancel': {
		label: "Đã hủy",
		color: 'red',
	},
}
export const LIST_PAPER_NUMBER_STATUS = {
	'pending': {
		label: "Đợi phát",
		color: 'yellow',
	},
	'allow': {
		label: "Đã phát",
		color: 'blue',
	},
	'success': {
		label: "Đã thu",
		color: 'green',
	},
	'cancel': {
		label: "Đã hũy",
		color: 'red',
	},
}

export const CAREERS = [
	{ value: 'fashion', label: 'Thời trang'},
	{ value: 'cosmetics', label: 'Mỹ phẩm'},
	{ value: 'technology', label: 'Công nghệ'},
	{ value: 'phoneLaptop', label: 'Điện thoại - Laptop'},
	{ value: 'MotorcycleCar', label: 'Xe máy - ô tô'},
	{ value: 'mechanical', label: 'Cơ khí'},
	{ value: 'food', label: 'Thực phẩm'},
	{ value: 'freshFood', label: 'Thực phẩm tươi sóng'},
	{ value: 'functionalFood', label: 'Thực phẩm chức năng'},
	{ value: 'milkTeaDrink', label: 'Trà sữa - thức uống'},
	{ value: 'interior', label: 'Nội thất'},
	{ value: 'householdAppliances', label: 'Đồ gia dụng'},
	{ value: 'build', label: 'Xây dựng'},
	{ value: 'refrigeration', label: 'Điện lạnh'},
	{ value: 'electricity', label: 'Điện máy'},
	{ value: 'electricalEquipment', label: 'Thiết bị điện'},
	{ value: 'sanitaryEquipment', label: 'Thiết bị vệ sinh'},
	{ value: 'realEstate', label: 'Bất động sản'},
	{ value: 'travel', label: 'Du lịch'},
	{ value: 'hotelRestaurant', label: 'Khách sạn - Nhà Hàng'},
	{ value: 'transportation', label: 'Vận tải'},
	{ value: 'beautySpa', label: 'Spa làm đẹp'},
	{ value: 'studio', label: 'Studio'},
	{ value: 'motherBaby', label: 'Mẹ & bé'},
	{ value: 'education', label: 'Giáo dục'},
	{ value: 'stationery', label: 'Văn phòng phẩm'},
	{ value: 'sport', label: 'Thể thao'},
	{ value: 'eventOrganization', label: 'Tổ chức sự kiện'},
	{ value: 'medical', label: 'Y tế'},
	{ value: 'medicinalHerbs', label: 'Dược liệu'},
];